import { mapValues } from '../_internal/data';
var SIZES = {
    desktop: 1296,
    tablet: 1024,
    smallTablet: 768,
    phone: 600,
};
export var breakpoints = {
    above: mapValues(SIZES, function (value) { return "min-width: ".concat((value + 1) / 16, "em"); }),
    below: mapValues(SIZES, function (value) { return "max-width: ".concat(value / 16, "em"); }),
    raw: SIZES,
};
//# sourceMappingURL=breakpoints.js.map